import { NavLink } from 'react-router-dom';
import './NavBar.css';
import HamburgerMenu from "./hamburger/hamburger";
import logo from '../../assets/photos/HG_sunset_logo_transparent_v2_256.png';

const leftItems = [
  { label: "FAQ", path: "/Info" },
  { label: "ROADMAP", path: "/Roadmap" },
  { label: "NEWS", path: "/News" },
];

const centerItem = {
  label: "PLAY",
  path: "/Play",
};

const rightItems = [
  {
    label: "RESOURCES",
    type: "dropdown",
    children: [
      { label: "THE JOURNEY", path: "/RevivalJourney" },
      { label: "LEADERBOARD", path: "/Leaderboard" },
      { label: "COMPONENT VIEWER", path: "/ComponentViewer" },
    ],
  },
  //{ label: "DONATE", path: "/Support" },
];

function NavigationBar() {
  return (
    <div className="NavigationBar">

      <div className="logo-wrapper">
        <NavLink className="logo" to="/">
          <img src={logo} alt="Site Logo" className="logo-image" />
        </NavLink>
      </div>

      <div className="nav-list">

        <div className="nav-left">
          {leftItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className="NavigationBarItem"
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <NavLink
          to={centerItem.path}
          className="NavigationBarItem primary nav-center"
        >
          {centerItem.label}
        </NavLink>

        <div className="nav-right">
          {rightItems.map((item) =>
            item.type === "dropdown" ? (
              <div className="nav-dropdown" key={item.label}>
                <span className="NavigationBarItem">
                  {item.label}
                </span>

                <div className="dropdown-menu">
                  {item.children.map((child) => (
                    <NavLink
                      key={child.path}
                      to={child.path}
                      className="dropdown-item"
                    >
                      {child.label}
                    </NavLink>
                  ))}
                </div>
              </div>
            ) : (
              <NavLink
                key={item.path}
                to={item.path}
                className="NavigationBarItem"
              >
                {item.label}
              </NavLink>
            )
          )}
        </div>

      </div>

      <HamburgerMenu
        leftItems={leftItems}
        centerItem={centerItem}
        rightItems={rightItems}
      />
    </div>
  );
}

export default NavigationBar;